export default {
  "successStep": {
    "loadingTitle": "¡Solicitud Recibida!",
    "loadingDescription": "Gracias <nameSpan>{{firstName}}</nameSpan>, tu solicitud ha sido recibida. Estamos verificando la disponibilidad de nuestro equipo para ayudarte...",
    "checkingAvailability": "Verificando disponibilidad",
    "scheduleHeadingCongrats": "¡Felicidades, {{firstName}}!",
    "eligibleUpTo": "Calificas para hasta {{amount}}",
    "backToContactOptions": "Volver a Opciones de Contacto",
    "receivedTitle": "¡Solicitud Recibida!",
    "congratsTitle": "¡Felicidades, {{firstName}}!",
    "thankYouAppointment": "Gracias <nameSpan>{{firstName}}</nameSpan>, esperamos hablar contigo el <timeSpan>{{time}}</timeSpan>",
    "incomingCallFrom": "Llamada entrante de: {{number}}",
    "scheduleButtonLabel": "Programar Cita",
    "missedCallTitle": "¿Perdiste nuestra llamada?",
    "missedCallDescription": "Puedes contactarnos en:",
    "scheduleFailedError": "No pudimos programar tu llamada. Inténtalo de nuevo o llámanos directamente.",
    "variants": {
      "appointmentScheduled": {
        "title": "Cita Programada",
        "description": "Para asistencia inmediata antes de tu cita, llama al:"
      },
      "callInitiated": {
        "title": "Llamada en Curso",
        "description": "Por favor responde la llamada entrante."
      },
      "contactSpecialists": {
        "title": "Contacta a Nuestros Especialistas en Soluciones",
        "description": "Llámanos directamente o programa una llamada de regreso a una hora conveniente."
      },
      "immediateSchedule": {
        "title": "Programa Tu Consulta",
        "description": "Programa una hora conveniente para que te llamemos."
      },
      "scheduleCallback": {
        "title": "Programa una Llamada de Regreso",
        "description": "Tenemos agentes esperando tu llamada. Llámanos directamente o programa una llamada de regreso."
      },
      "giveUsACall": {
        "title": "Llámanos para hablar sobre tu solicitud de préstamo",
        "description": ""
      },
      "weekendContactSpecialists": {
        "title": "Contacta a Nuestros Especialistas en Soluciones",
        "description": "Tenemos agentes esperando tu llamada. Llámanos directamente o programa una llamada de regreso a una hora más conveniente."
      },
      "fallbackSchedule": {
        "title": "Programa Tu Consulta",
        "description": "Programa una hora conveniente para hablar sobre tu solicitud."
      }
    }
  },
  "unsuccessful": {
    "title": "Se Requiere Verificación de Identidad",
    "description": "Para proteger tu seguridad y mantener la integridad de nuestra plataforma de préstamos, no pudimos verificar tu identidad con la información proporcionada.",
    "cta": "Explorar Opciones Alternativas"
  },
  "blocked": {
    "unsuccessfulTitle": "Solicitud Sin Éxito",
    "unsuccessfulDescription": "No pudimos verificar tu información. Puedes volver a intentarlo después del {{date}}.",
    "checkMoneyLionOffers": "Ver Ofertas de MoneyLion",
    "backToContactOptions": "Volver a Opciones de Contacto",
    "alreadySubmittedTitle": "Solicitud Ya Enviada",
    "appointmentScheduled": "Cita Programada",
    "callbackScheduledFor": "Tu llamada de regreso está programada para:",
    "immediateAssistance": "Para asistencia inmediata antes de tu cita:",
    "contactSpecialistsHeading": "Contacta a Nuestros Especialistas en Préstamos",
    "chooseHowToConnect": "Elige cómo te gustaría contactarnos:",
    "scheduleAppointment": "Programar Cita",
    "previousDetailsHeading": "Detalles de tu Solicitud Anterior",
    "loanAmountLabel": "Monto del Préstamo",
    "loanPurposeLabel": "Propósito del Préstamo",
    "employmentStatusLabel": "Situación Laboral",
    "propertyStatusLabel": "Situación de Vivienda",
    "applyAgainAfter": "Puedes volver a aplicar después del <dateSpan>{{date}}</dateSpan>",
    "warningTitle": "¡Advertencia!",
    "warningMessage": "Iniciar una nueva solicitud antes de que expire el período de espera puede causar demoras o complicaciones con tu solicitud existente. ¿Estás seguro de que deseas continuar?",
    "confirmReset": "Sí, iniciar nueva solicitud",
    "cancelReset": "Cancelar",
    "startNew": "Iniciar nueva solicitud"
  },
  "scheduleCall": {
    "title": "Programa una Llamada",
    "description": "Hola {{firstName}}, nuestro equipo está ocupado o estás llamando fuera del horario de atención. Selecciona una hora conveniente para que te llamemos al {{phoneNumber}}.",
    "loading": "Cargando horarios disponibles...",
    "unableToLoad": "No se pudieron cargar los horarios",
    "loadFailedError": "No se pudieron cargar los horarios disponibles. Inténtalo de nuevo.",
    "refreshFailedError": "No se pudo actualizar la disponibilidad. Inténtalo de nuevo.",
    "refreshPage": "Actualiza la página para volver a intentarlo",
    "noSlotsTitle": "No hay horarios disponibles",
    "noSlotsDescription": "Actualmente no hay citas disponibles. Inténtalo más tarde o contáctanos directamente.",
    "timesAvailable": "{{available}} de {{total}} horarios disponibles",
    "backToDates": "Volver a las fechas",
    "changeTime": "Cambiar hora",
    "appointmentDetails": "Detalles de la Cita",
    "callbackScheduledFor": "Tu llamada de regreso está programada para:",
    "confirm": "Programar Llamada",
    "allTimesShownIn": "Todos los horarios se muestran en {{tz}} ({{abbr}})"
  }
} as const;
